import React, { useContext } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { Switch } from "@design-system/Switch/Switch";
import {
    PaginatedTransactionsActionsContext,
    PaginatedTransactionsDataContext,
} from "../PaginatedTransactionsTable.context";
import styles from "./RulesSuggestionToggle.module.scss";

export const RulesSuggestionToggle: React.FC = () => {
    const { isRulesSuggestionAvailable, isRulesSuggestionEnabled } = useContext(
        PaginatedTransactionsDataContext,
    );
    const { setRulesSuggestionEnabled } = useContext(
        PaginatedTransactionsActionsContext,
    );
    if (!isRulesSuggestionAvailable) {
        return null;
    }

    return (
        <Tooltip content="Suggest rules after editing fields a rule can update">
            <Switch
                checked={isRulesSuggestionEnabled}
                onCheckedChange={setRulesSuggestionEnabled}
                label="Rules"
                size="sm"
                className={styles.pill}
            />
        </Tooltip>
    );
};
